import { captureWarning } from '../../logger/Logger';
import { fetchDeviceToken } from '../api/AuthApi';
import { storeDeviceToken } from '../helpers';

export const registerDeviceToken = async (
    stytchUserId: string,
    stytchSessionId: string,
) => {
    const deviceToken = await fetchDeviceToken({
        stytchId: stytchUserId,
        sessionId: stytchSessionId,
        isFirstLogin: true,
    });

    if (deviceToken == null) {
        captureWarning('unable to verify device with jwt');
    } else {
        storeDeviceToken(deviceToken);
    }
};
